// 图片预览
export default {
  state: {
    show: false,
    imgs: [],
    activeIndex: 0
  },

  mutations: {
    HIDE_SWIPE (state) {
      state.show = false
    },

    SHOW_SWIPE (state) {
      state.show = true
    }
  },

  actions: {
    initSwipe ({state, commit}, {imgs, index}) {
      state.imgs = imgs
      state.activeIndex = index
      commit('SHOW_SWIPE')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/swipe.js